import { jsx as a } from "react/jsx-runtime";
import { forwardRef as p } from "react";
import s from "@mui/material/Pagination";
import l from "styled-components";
import r from "./PaginationItem.js";
const g = {
  root: "paginationRoot",
  component: "paginationComponent",
  disabled: "paginationDisabled",
  label: "paginationLabel"
}, m = l(s).withConfig({
  displayName: "StyledPagination"
})([
  "&&.paginationRoot{}&&.paginationRoot:hover{}&&.paginationRoot.selected{}&&.paginationDisabled{}&&.paginationLabel{}"
]), d = /* @__PURE__ */ p(({ classes: o, renderItem: i = (e) => /* @__PURE__ */ a(r, {
  ...e
}), ...t }, n) => /* @__PURE__ */ a(m, {
  ...t,
  ref: n,
  renderItem: i,
  classes: {
    ...g,
    ...o
  }
}));
d.displayName = "Pagination";
export {
  d as default
};
